<template>
    <section>
        <div v-if="show" :class="['intro_c']">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <defs>
                    <linearGradient id="gradient">
                        <stop offset="0%" style="stop-color: #005be2;" />
                        <stop offset="100%" style="stop-color: #13de7d" />
                    </linearGradient>
                    <mask id="mask">
                        <rect x="0" y="0" :width="width" :height="height" fill="#ffffff" />
                        <template v-if="executeWd.type === 'circle_' && showBlockWindow">
                            <circle :cx="circle.cx" :cy="circle.cy" :r="circle.r" fill="#000000" />
                        </template>
                        <template v-if="executeWd.type === 'rect_' && showBlockWindow">
                            <rect
                                :x="rect.x - rr" :y="rect.y - rr - 60"
                                :height="rect.height + rr * 2" :width="rect.width + rr * 2"
                                :rx="rx" :ry="rx"
                                fill="#000000" />
                        </template>
                    </mask>
                </defs>
                <rect x="0" y="0" :width="width" :height="height"  fill="rgba(0, 0, 0, .6)" mask="url(#mask)" />
                <template v-if="executeWd.type === 'rect_' && showBlockWindow">
                    <rect
                        :x="rect.x - rr" :y="rect.y - rr - 60"
                        :height="rect.height + rr * 2" :width="rect.width + rr * 2"
                        :rx="rx" :ry="rx"
                        fill="#000000" fill-opacity="0" stroke="url(#gradient)" stroke-width="5" />
                </template>
        
                <template v-if="executeWd.type === 'circle_' && showBlockWindow">
                    <circle :r="Number(circle.r) + 2.5" :cx="circle.cx" :cy="circle.cy" fill="#000000" fill-opacity="0" stroke="url(#gradient)" stroke-width="5" />
                </template>
            </svg>
            <IntroWindow ref="reactWindow" :class="shit$(`opacity:${showBlockWindow ? 1 : 0};`)" /> 
            <!-- v-show="showBlockWindow" -->
        </div>
        <IntroBox />
        <MissionRepeat />
    </section>
</template>

<script>
import { mapState } from 'vuex'
import IntroWindow from '@/code-lab/component/intro/intro-window.vue'
import IntroBox from '@/code-lab/component/intro/introBox.vue'
import MissionRepeat from '@/code-lab/component/intro/mission-repeat.vue'
export default {
    components: {
        IntroWindow, IntroBox, MissionRepeat
    },
    data () {
        return {
            rx: 18,
            rr: 8,
            cc: 6,
            t: null,
            height: 0,
            width: 0,
            circle: {
                cx: 0, cy: 0, r: 0
            },
            rect: {
                height: 0, width: 0, x: 0, y: 0
            },
        }
    },
    computed: {
        ...mapState('introStore', {
            executeWd: 'executeWd',
            show: 'show',
            showBlockWindow: 'showBlockWindow',
            currentExe: 'currentExe'
        })
    },
    watch: {
        executeWd: {
            handler (val) {
                this.cc = this.executeWd.cc || 6
                this.rr = this.executeWd.rr || 8
                const { target } = val
                this.t = target
                this.update()
            }
        },
        showBlockWindow () {
            this.$nextTick(() => {
                this.computedAdapt()
            })
        }
    },
    mounted () {
        window.addEventListener('resize', this.update)
    },
    methods: {
        circle_ () {
            let hh, yy, xx, ww, bb
            const fn = this.executeWd.fn
            if (fn) {
                Array.from(this.t.children).filter((fl, fi) => fn(fi)).forEach(ele => {
                    const { x, y, height, width, bottom } = ele.getBoundingClientRect()
                    hh = hh || height
                    yy = yy || y
                    xx = xx || x
                    ww = ww || width
                    bb = bottom
                })
            } else {
                const { x, y, width, height, bottom } = this.t.getBoundingClientRect()
                hh = height
                yy = y
                xx = x
                ww = width
                bb = bottom
            }

            const r = Number( Math.sqrt((Math.ceil(ww * hh) / Math.PI) ).toFixed(2) ) + this.cc
            
            this.circle = { cx: xx + ww / 2, cy: yy - 60 + hh / 2, r }
            this.show_({ height: hh, x: xx, y: yy, width: ww, r, bottom: bb })
        },
        rect_ () {
            let hh = 0, yy, xx, ww = 0, bb = 0
            const fn = this.executeWd.fn
            if (fn) {
                Array.from(this.t.children).filter((fl, fi) => fn(fi)).forEach(ele => {
                    const { x, y, height, width, bottom } = ele.getBoundingClientRect()
                    hh = hh || height
                    yy = yy || y
                    xx = xx || x
                    ww += width
                    bb = bottom
                })
            } else {
                const { x, y, width, height, bottom } = this.t.getBoundingClientRect()
                hh = height
                yy = y
                xx = x
                ww = width
                bb = bottom
            }
            
            Object.assign(this.rect, { width: ww, height: hh, x: xx, y: yy })
            this.show_({ height: hh, x: xx, y: yy, width: ww, bottom: bb })
        },
        document_ () {
            const { width, height } = document.documentElement.getBoundingClientRect()
            Object.assign(this, { width, height })
        },
        computedAdapt () {
            const r = (this.$refs.reactWindow && this.$refs.reactWindow.$el.getBoundingClientRect()) || {}
            const w = document.documentElement.getBoundingClientRect()
            let data
            if (r.bottom >= w.bottom && this.executeWd.position === 'right' && this.currentExe !== 'missionDB' ) {
                data = { top: w.height - r.height }
            }
            data && this.$store.commit('introStore/upRect', [ { top: data.top } ])
            return data
        },
        show_ ({ height, x, y, width, r }) {
            const { clientW, offsetRct, position } = this.executeWd
            const clientH = (this.$refs.reactWindow && this.$refs.reactWindow.$el.clientHeight) || 0
            this.$nextTick(() => {
               this.computedAdapt( )
            })
            if (position === 'right') {
                this.$store.commit('introStore/upRect', [ { offset: offsetRct, hh: height, left: x - clientW - 40 - offsetRct, top: y - clientH + height + offsetRct , z: 100 } ])
            } else if (position === 'top') {
                this.$store.commit('introStore/upRect', [ { rr: this.rr, offset: offsetRct, ww: width, hh: height, left: x - clientW + width, top: y + (height + this.rr) + 12 + offsetRct , z: 100 } ])
            } else if (position === 'left') {
                this.$store.commit('introStore/upRect', [ { rr: this.rr, offset: offsetRct, ww: width, hh: height, left: x + (width / 2 + r + 12 + 5 + 2.5) + 10, top: y - clientH + height + offsetRct , z: 100 } ])
            } else if (position === 'bottom') {
                this.$store.commit('introStore/upRect', [ { rr: this.rr, offset: offsetRct, ww: width, hh: height, left: x - clientW + width, top: y - clientH - 40 + offsetRct , z: 100 } ])
            }
        },
        draw_() {
            const { type } = this.executeWd
            this[type]()
        },
        update () {
            setTimeout(() => {
                if (!this.t) return
                this.draw_()
                this.document_()
                this.$store.commit('introStore/upShowBlockWindow', [true])
            }, 600)
        }
    },
}
</script>

<style scoped>
.intro_c {
    position: fixed;
    top: 60px;
    left: 0px;
    z-index: 2000;
    width: 100%;
    height: 100%;
}
svg {
    width: 100%;
    height: 100%;
}
</style>
